import React, {FC} from 'react'
import classnames from 'classnames'
import {Tabs} from 'antd'
import StylesType from '@/types/StylesType'
import {PricesType} from '@/types/NewMachineTypes'
import secondToDay from '@/utils/secondToDay'
import {Grade} from '@/stores/user/NewMachine/IPService'
import {IdType} from '@/types/IdTypes'

import './style/Prices.less'


export interface Price {
  price: PricesType;
  priceId?: IdType|null;
  changePriceId?: (price: PricesType) => void;
}

// 一键新机选择类型
export const Price: FC<Price & StylesType> = props => {
  const {prefixCls = 'gc_', className, price, changePriceId, priceId} = props

  return (
    <div className={classnames(className, prefixCls + 'machine_time_item', {actived: priceId === price.id})}
         onClick={() => changePriceId&&changePriceId(price)}>
      <div className={classnames('item_title')}>{secondToDay(price.period)}</div>
      <div className={classnames('item_price')}><span
        className={classnames('money_unit')}>¥</span>{(price.real_price/100).toFixed(2)}</div>
    </div>
  )
}

export interface PricesPros {
  prices: PricesType[];
  priceId: IdType|null;
  changePriceId: (price: PricesType) => void;
}

const Prices: FC<StylesType & PricesPros> = props => {
  const {prefixCls = 'gc_', className, prices, priceId, changePriceId} = props

  return (
    <div className={classnames(className, prefixCls + 'machine_time')}>
      <div className={classnames('title')}>购买一键新机</div>
      <div className={classnames('machine_time_items')}>
        {prices.map(item => {
          return <Price price={item} key={item.id} priceId={priceId} changePriceId={changePriceId}></Price>
        })}
      </div>
    </div>
  )
}

interface IpPricesProps {
  changeGrade?: (id: string) => void;
  gradeList?: Grade[]
}

const {TabPane} = Tabs;
export const IpPrices: FC<StylesType & PricesPros & IpPricesProps> = props => {
  const {prefixCls = 'gc_', className, prices, priceId, changePriceId, changeGrade, gradeList} = props
  return (
    <div className={classnames(className, prefixCls + 'machine_time')}>
      <div className={classnames('title')}>购买IP服务</div>
      <Tabs defaultActiveKey="1" onChange={changeGrade}>
        {gradeList&&gradeList.map(tab => {
          return (<TabPane tab={tab.name} key={String(tab.id)}>
              <div className={classnames('machine_time_items')}>
                {prices.map(item => {
                  return <Price price={item} key={item.id} priceId={priceId} changePriceId={changePriceId}></Price>
                })}
              </div>
            </TabPane>
          )
        })}
      </Tabs>
    </div>
  )
}

export default Prices
